import {Button, Modal} from "antd";
import ReactToPrint from "react-to-print";
import React from "react";
import moment from "moment";
import {PrinterOutlined} from "@ant-design/icons";
import "moment/locale/tr";

export const ReceiptPrinter = ({
    receiptModalVisible,
    setReceiptModalVisible,
    receiptRef,
    order,
    orderData,
    setIsReceiptPrinting,
    isReceiptPrinting,
    createdAt,
    customerCreatedAt
}) => {
    return (
        <Modal
            visible={receiptModalVisible}
            onCancel={() => setReceiptModalVisible(false)}
            cancelText=""
            cancelButtonProps={{
                style: {
                    display: "none"
                }
            }}
            onOk={() => setReceiptModalVisible(false)}
            okText={"Tamam"}
        >
            {
                <div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            gap: "10px",
                            fontSize: "16px"
                        }}
                    >
                        <div
                            ref={receiptRef}
                            style={{
                                fontFamily: "Arial, sans-serif",
                                width: "300px",
                                border: "1px solid #000",
                                padding: "10px",
                                fontSize: "16px"
                            }}
                        >
                            <h4
                                style={{
                                    textAlign: "center"
                                }}
                            >
                                {`${order?.pickupInfoCompanyName} - ${order?.pickupInfoName}`}
                            </h4>
                            <p
                                style={{
                                    textAlign: "center",
                                    margin: 0,
                                    fontSize: "16px"
                                }}
                            >
                                Sipariş Bilgi Fişi
                            </p>
                            <p
                                style={{
                                    textAlign: "center",
                                    margin: 0
                                }}
                            >
                                {customerCreatedAt
                                    ? customerCreatedAt
                                    : createdAt
                                    ? moment(createdAt).format("DD.MM.YYYY HH:mm")
                                    : moment(orderData?.data?.delivery?.createdAt).format(
                                          "DD.MM.YYYY HH:mm"
                                      )}
                            </p>
                            <hr />
                            <p>Sipariş No: {order?.orderNumber}</p>
                            <b>
                                {order?.receiverName} <br /> {order?.receiverPhone}
                            </b>
                            <p>
                                <strong>Adres:</strong>
                            </p>
                            <b>{order?.receiverAddress}</b>
                            {order?.receiverAddressDetail && (
                                <>
                                    <p>
                                        <strong>Adres Detayı:</strong>
                                    </p>
                                    <b>{order?.receiverAddressDetail}</b>
                                </>
                            )}
                            <hr />
                            <p>Sipariş Detayları:</p>

                            {order?.products.map((product, index) => (
                                <b key={index.toString()}>
                                    {product?.amount} - {product?.productName}
                                </b>
                            ))}

                            <hr />
                            <p
                                style={{
                                    textAlign: "right"
                                }}
                            >
                                <strong>{order?.price}₺</strong>
                            </p>
                            <hr />
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: "10px"
                                }}
                            >
                                <p>Vigo</p>
                                <p>
                                    <strong>vigovigo.com</strong>
                                </p>
                            </div>
                        </div>
                        <ReactToPrint
                            content={() => receiptRef.current}
                            onBeforePrint={() => {
                                setIsReceiptPrinting(true);
                            }}
                            onAfterPrint={() => {
                                setIsReceiptPrinting(false);
                                setReceiptModalVisible(false);
                            }}
                            trigger={() => (
                                <Button
                                    loading={isReceiptPrinting}
                                    type="primary"
                                    icon={<PrinterOutlined />}
                                >
                                    Fişi Yazdır
                                </Button>
                            )}
                        />
                    </div>
                </div>
            }
        </Modal>
    );
};
